import { useTranslation } from 'react-i18next'
import GhostButton from '../../Buttons/GhostButton'
import { ProductType } from '../../../interfaces/pricingPlan'

interface PlanHeaderProps {
  /** Null for a plan whose product declares no type; neither pill is marked
   *  rather than one of them being wrong. */
  tier: ProductType | null
  handleChange: (productType: ProductType) => void
}

const PlanProductType = ({ tier, handleChange }: PlanHeaderProps) => {
  const { t } = useTranslation()

  return (
    <div className='flex items-center bg-blue-100/60 p-1 rounded-full flex-shrink-0'>
      <GhostButton
        onClick={() => handleChange('company')}
        className={`rounded-full px-6 transition-colors  ${
          tier === 'company'
            ? 'bg-white text-primaryBlue shadow-sm hover:bg-white font-medium'
            : 'text-lightGray hover:text-primaryBlue'
        }`}
        label={t('companies')}
      />
      <GhostButton
        onClick={() => handleChange('university')}
        className={`rounded-full px-6 transition-colors ${
          tier === 'university'
            ? 'bg-white text-primaryBlue shadow-sm hover:bg-white font-medium'
            : 'text-lightGray hover:text-primaryBlue'
        }`}
        label={t('universities')}
      />
    </div>
  )
}

export default PlanProductType
